require('../modules/web.timers');
require('../modules/web.immediate');
require('../modules/web.dom.iterable');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/web/index.js
// module id = YOtp
// module chunks = 0